module.exports = __webpack_public_path__ + "img/alert2.852e962e.png";